import download from './download.vue'
import Vue from 'vue'
let downloadCoustroctor = Vue.extend(download);

export default {
  download(params) {
    let instance = new downloadCoustroctor({
      data: params
    })
    let instanceNode = instance.$mount();
    document.body.appendChild(instanceNode.$el);
  }
}